import React, { useContext } from 'react';

const ThemeContext = React.createContext('');

const useTheme = (themes = {}) => {
  const key = useContext(ThemeContext);
  return themes[key] || themes.fallback || '';
};

const Themed = (props) => {
  const theme = useTheme(props);
  return props.children(theme);
};

export { ThemeContext, useTheme, Themed };

export default Themed;
